module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/review-dc6ed51f4f43a68f22c40e60b7d5f23c.webp";